import { verifyUserNameAPI } from "utils/HttpUrlConstants";

export const getValueFromState = (searchString: string, stateDecoded: string) => {
  const indexOfString = stateDecoded.indexOf(searchString)
  const ch = '&'
  let indexOfEndOfString = stateDecoded.indexOf(ch, indexOfString);
  if (indexOfString != -1 && indexOfEndOfString === -1) {
    indexOfEndOfString = stateDecoded.length
  }
  const value = indexOfString != -1 && indexOfEndOfString != -1 ? stateDecoded.substring(indexOfString, indexOfEndOfString) : ""
  if(value !== "" ) {
    return value.split('=')[1]
  }
  return ""
}

export const verify  = (userName: string, state: string, locale: string, key: string) : void => {
    fetch(verifyUserNameAPI(userName.includes('+') ? userName.replace('+', encodeURIComponent('+')) : userName, state, locale, key), {
      method: 'get' 
  }).then(response => {
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json().then(data => {
              window.location.href = data
            });
          } else {
            const stateDecoded = atob(state)
            const redirectUri = getValueFromState("returnPath=", stateDecoded)
             window.location.href = redirectUri
          }
        });


  }

  export const getDecodedState = (state: string) => {
    return atob(state).split('&')
  }

  export const isOauthFlow = (state: string|null) => {
    if (state != null) {
        if (getDecodedState(state).includes('oauthFlow=true')) {
            return true
        }
    }
    return false
}

export const showCreateOneLink = (state: string|null) => {
  if (state != null) {
      if (getDecodedState(state).includes('showCreateOneLink=true')) {
          return true
      }
  }
  return false
}


